import React, { FC, CSSProperties } from "react";
import classNames from "classnames";

interface IEmptyStateBlocksProps {
  className?: string;
  style?: CSSProperties;
}

// eslint-disable-next-line react/prop-types
const EmptyStateBlocks: FC<IEmptyStateBlocksProps> = ({ className, ...rest }) => (
  <svg className={classNames("empty-state-blocks", className)} width="100" height="72" viewBox="0 0 110 72" {...rest}>
    <path className="empty-state-blocks__red" d="M74 18h18a18 18 0 01-18 18z" />
    <circle className="empty-state-blocks__purple" cx="64.96" cy="45" r="9" />
    <path className="empty-state-blocks__grey" d="M6.64 49.5h8.86a42.86 42.86 0 019-21v-9.35" />
    <path className="empty-state-blocks__blue" d="M56 54V18a36 36 0 00-36 36z" />
    <path className="empty-state-blocks__gold" d="M73.96 36h18v18h-18z" />
  </svg>
);

export default EmptyStateBlocks;
